export default __webpack_public_path__ + "static/media/default.4a13c1e7.svg";